import { Button, Typography } from '@sky-distribution/react-commons-ui';
import styled, { css } from 'styled-components';

export const GeneralPageContainer = styled.div`
  max-width: clamp(17.5rem, 100%, 87.5rem);
  margin: auto;
  padding: 0 2rem;
  height: 100vh;
  display: flex;
  align-items: center;
  box-sizing: border-box;
`;

export const GeneralPageGrid = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 20rem repeat(2, 4rem);
  gap: 3rem;

  ${({ theme }) => theme.down(theme.breakpoints.md)} {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    justify-items: center;
    gap: 2rem;
  }
`;

export const GeneralPagePicture = styled.picture<{ maxWidth?: number }>`
  display: flex;
  justify-self: center;
  grid-column: 2;
  grid-row: 1 / -1;

  ${({ maxWidth }) => maxWidth && css`
    max-width: ${maxWidth}rem
  `};

  ${({ theme }) => theme.down(theme.breakpoints.md)} {
    grid-column: 1;
    grid-row: 2;
  }
`;

export const GeneralPageImage = styled.img`
  display: block;
  height: 100%;
  width: 100%;
`;

export const GeneralPageContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const GeneralPageMessage = styled(Typography)`
  margin: 0;
  line-height: 1.2;
  font-size: 3rem;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.text.header};

  ${({ theme }) => theme.down(theme.breakpoints.md)} {
    font-size: 1.5rem;
    text-align: center;
  }
`;

export const GeneralPageButton = styled(Button)`
  max-width: 23.125rem;
  font-size: 1rem;
`;

export const GeneralPageText = styled(Typography)`
  max-width: 23.125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  text-transform: uppercase;
  font-size: 1rem;
  color: ${({ theme }) => theme.palette.input.text.base};

  &::before,
  &::after {
    content: '';
    border-bottom: 0.0625rem solid ${({ theme }) => theme.palette.commons.tonal.base};
    width: 1.5rem;
  }
`;
